// import trust_edge_logo from "assets/images/TE_logo.png";
import trust_edge_logo from "../Footer/assets/trust_edge_footer_logo.png";
import iitb_banner_new from "assets/images/iitb_banner.webp";
import certificate_banner from "assets/images/new_certificate_banner.png";
import mobile_certificate_banner from "assets/images/mobile_certificate_banner.png";
// import educationpostlogo from "assets/news/education-post-logo.png"
import hindustan_times_logo from "assets/news/hindustan-times-logo.png"
import timesofindia_logo from "assets/news/the-times-of-india-logo.png"
import india_today_logo from "assets/news/india-today.jpg"
import the_hindu_logo from "assets/news/the-hindu-newspaper-logo.png"
// import "./trustEdgeLanding.css";

import { Container, Row, Image, Col } from "react-bootstrap";
import { useMediaQuery } from 'react-responsive';
import { courses } from "Constants/courses";
import CourseCard from "Screens_old/CourseCard/CourseCard";
import FooterTrust from "Screens_old/Footer/FooterTrust";
import ReviewSlider from "Screens_old/ReviewSlider/ReviewSlider";
import { stepsToAdoptBodhitree } from "./data";
import { classNames } from "Store/utils";
import trustEdgeStyles from "TrustEdge.module.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const TrustEdgeLanding = (props) => {
  const location = useLocation();

  // Media query hook for responsive behavior
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const allReviews = courses
    .map((course) => {
      const courseReviews = course.reviews || [];
      return [...courseReviews];
    })
    .flat();

  // Press coverage data with images
  const pressCoverage = [
    {
      outlet: "Times of India",
      title: "IIT Bombay launches certificate programmes in cybersecurity and software development",
      url: "https://timesofindia.indiatimes.com/education/news/iit-bombay-launches-certificate-programmes-in-cybersecurity-and-software-development-check-how-to-apply/articleshow/122815130.cms",
      image: timesofindia_logo
    },
    {
      outlet: "Hindustan Times",
      title: "IIT Bombay launches professional certificate programs in cybersecurity, software development",
      url: "https://www.hindustantimes.com/education/iit-bombay-launches-professional-certificate-programs-in-cybersecurity-software-development-101753087663319.html",
      image: hindustan_times_logo
    },
    {
      outlet: "The Hindu",
      title: "IIT Bombay launches professional certificate programs in cybersecurity and software development",
      url: "https://www.thehindu.com/education/colleges/iit-bombay-launches-professional-certificate-programs-in-cybersecurity-and-software-development/article69837777.ece",
      image: the_hindu_logo
    },
    {
      outlet: "India Today",
      title: "IIT Bombay introduces one-year online certificate programmes in cybersecurity and software development",
      url: "https://bestcolleges.indiatoday.in/news-detail/iit-bombay-introduces-one-year-online-certificate-programmes-in-cybersecurity-and-software-development-4610",
      image: india_today_logo
    },
  ];

  // {
  //     outlet: "Education Post",
  //     title: "IIT Bombay introduces online certification programs in cybersecurity and software development",
  //     url: "https://educationpost.in/news/education/iit-bombay-introduces-online-certification-programs-in-cybersecurity-and-software-development",
  //     image: educationpostlogo
  //   }

  useEffect(() => {
    // Handle scroll from navigation state
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        setTimeout(() => {
          const yOffset = -80; // Adjust this value based on your header height
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 100);
      }
    }

    // Handle scroll from URL hash
    if (location.hash) {
      const elementId = location.hash.substring(1);
      const element = document.getElementById(elementId);
      if (element) {
        setTimeout(() => {
          const yOffset = -80; // Adjust this value based on your header height
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      <Container
        fluid
        className={classNames("pl-0 pr-0", trustEdgeStyles['landingImageParent'])}
      // style={{ userSelect: "none" }}
      >
        <Row className="ml-0 mr-0">
          <Col
            md={5}
            className="d-flex flex-column justify-content-center"
          >
            <div className="row">
              <Col
                xs={12}
                md={12}
                className="pt-2 pl-md-5 pr-md-5 d-flex justify-content-start"
              >
                <Image
                  width={`400px`}
                  src={trust_edge_logo}
                  alt="IITB logo"
                  style={{ background: "white" }}
                  className="img-fluid p-2"
                />
              </Col>
              <Col
                xs={12}
                md={12}
                className="pl-md-5 pr-md-5 pt-4 text-white text-left"
              >
                <p className="p-0 m-0 trustedge_size48 d-none d-md-block font-weight-bold">
                  Quality
                  <span style={{ color: "#FFC24A" }}> Hands-on </span>
                </p>
                <p className="trustedge_size48 d-none d-md-block font-weight-bold">Technical Education</p>

                {/* Mobile version with smaller font */}
                <p className="p-0 m-0 trustedge_size41 d-block d-md-none font-weight-bold">
                  Quality
                  <span style={{ color: "#FFC24A" }}> Hands-on </span>
                </p>
                <p className="trustedge_size41 d-block d-md-none font-weight-bold">Technical Education</p>
              </Col>
            </div>
          </Col>
          <Col md={7} className="pl-0 pr-0">
            <Image
              className="iitb_banner w-100"
              src={iitb_banner_new}
              style={{ objectFit: "cover" }}
            />
          </Col>
        </Row>
      </Container>

      {/* </Container> */}
      {/* Press Coverage Section */}
      <Container fluid className={classNames(trustEdgeStyles['container-width'], "py-4 py-md-5")}>
        <Container className="py-5" style={{ backgroundColor: "#f2f5fa" }}>
          <Row>
            <Col xs={12} className="text-center mb-4">
              <h2 className="px-4">Press Coverage</h2>
              <p className="text-muted" style={{ fontSize: "14px" }}>Recent coverage from July 21, 2025</p>
            </Col>
          </Row>

          {/* Horizontal scrolling container for mobile, flex wrap for larger screens */}
          <div
            className={`d-flex ${isMobile ? 'flex-column align-items-center' : 'flex-wrap justify-content-center'}`}
            style={{
              gap: "12px",
              paddingBottom: "16px"
            }}
          >
            {pressCoverage.map((article, index) => (
              <div
                key={index}
                className="flex-shrink-0"
                style={{
                  minWidth: isMobile ? "280px" : "240px",
                  maxWidth: isMobile ? "280px" : "280px",
                  width: isMobile ? "280px" : "auto",
                  flex: isMobile ? "none" : "1"
                }}
              >
                <div
                  className="h-100 w-100 p-3 p-md-3"
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    cursor: "pointer",
                    height: "100%"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                  }}
                  onClick={() => window.open(article.url, '_blank', 'noopener,noreferrer')}
                >
                  <div className="d-flex flex-column h-100">
                    {/* Image and Outlet Header */}
                    <div className="d-flex flex-column align-items-start mb-3 text-center">
                      <div
                        style={{
                          width: "100%",
                          height: isMobile ? "200px" : "120px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "6px",
                          border: "1px solid #f0f0f0",
                          padding: "6px",
                          backgroundColor: "#eee",
                          marginBottom: isMobile ? "12px" : "8px"
                        }}
                      >
                        <Image
                          src={article.image}
                          alt={`${article.outlet} logo`}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            // Fallback for broken images
                            e.target.style.display = 'none';
                          }}
                        />
                      </div>
                      <h5
                        className="font-weight-bold mb-0"
                        style={{
                          color: "#007bff",
                          fontSize: isMobile ? "16px" : "16px",
                          lineHeight: "1.2"
                        }}
                      >
                        {article.outlet}
                      </h5>
                    </div>

                    {/* Article Title */}
                    <p
                      className="mb-0 flex-grow-1 text-left"
                      style={{
                        color: "#333",
                        fontSize: isMobile ? "14px" : "13px",
                        lineHeight: "1.3",
                        fontWeight: "400",
                        // Limit text height to maintain consistent card heights
                        display: "-webkit-box",
                        WebkitLineClamp: isMobile ? "3" : "2",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden"
                      }}
                    >
                      {article.title}
                    </p>

                    {/* Read Article Link */}
                    <div className={`${isMobile ? 'mt-3' : 'mt-2'} d-flex align-items-center justify-content-start`}>
                      <span
                        style={{
                          color: "#007bff",
                          fontSize: isMobile ? "14px" : "12px",
                          fontWeight: "500"
                        }}
                      >
                        Read Article
                      </span>
                      <span
                        style={{
                          marginLeft: isMobile ? "8px" : "6px",
                          color: "#007bff",
                          fontSize: isMobile ? "14px" : "12px"
                        }}
                      >
                        →
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </Container>

      <Container
        className="container-fluid pt-0 pt-md-3 pl-0 pr-0 d-flex flex-column justify-content-center align-items-center"
        style={{ minHeight: "50vh" }}
      >
        <Container className={classNames(trustEdgeStyles['container-width'])}>
          <h2
            className="size24 text-center text-md-left pl-0 py-md-2 pb-2 pt-1"
            style={{ fontWeight: "bold" }}
          >
            Our Unique Value Proposition: Why learn from us?
          </h2>
          <Row className="d-flex justify-content-center">
            {stepsToAdoptBodhitree.map((step, i) => {
              return (
                <Col
                  key={`${i}_step`}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  className="d-flex justify-content-center"
                >
                  <div
                    className="d-flex flex-column justify-content-start align-items-start  h-100"
                    style={{ paddingLeft: "8px", width: "100%" }}
                  >
                    <Image
                      src={step.image}
                      className="my-2"
                      alt="Feature Icon"
                    />
                    <p
                      className="trustedge_size18 font-weight-bold"
                      style={{ color: "#000", minHeight: "48px", display: "flex", alignItems: "flex-start" }}
                    >
                      {step.title}
                    </p>
                    <p
                      className={classNames("pl-0", trustEdgeStyles['size16'], "font-weight-normal text-left")}
                      style={{ color: "#757589" }}
                    >
                      {step.desc}
                    </p>
                  </div>
                </Col>
              );
            })}
          </Row>
          <Row>
            <Col sm={12} className="pb-5">
              <Image
                className="w-100"
                src={isMobile ? mobile_certificate_banner : certificate_banner}
                style={{ borderRadius: "10px" }}
                alt="Certificate Banner"
              />
            </Col>
          </Row>
        </Container>
        <Container
          fluid
          className={classNames(trustEdgeStyles['container-width'], "pt-2 pb-2 d-flex justify-content-center courses-section")}
          style={{ minHeight: "100vh" }}
        >
          <div className="py-4 w-100">
            <Row className="">
              {/* Programs Section */}
              <Col id="programs-we-offer" xs={12}>
                <h2 className="px-4">Programs we offer</h2>
              </Col>

              {/* Programs Cards */}
              {courses
                .filter((item) => item.category === "Professional Certificate")
                .map((item) => {
                  return (
                    <Col
                      key={item.id}
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      xl={4}
                      xxl={3}
                      className="mb-0 mb-md-3 d-flex justify-content-center"
                    >
                      <div style={{
                        width: "100%",
                        maxWidth: "350px",
                        minWidth: "280px",
                        display: "flex",
                        flexDirection: "column"
                      }}>
                        <CourseCard
                          id={item.id}
                          course_img={item.image}
                          course_title={item.program_title}
                          program_start_date={item.program_start_date}
                          duration={item.duration}
                          category={item.category}
                          program_type={item.program_type}
                          parent_program_ids={item.parent_program_ids}
                        />
                      </div>
                    </Col>
                  );
                })}

              {/* Courses Section */}
              <Col id="courses-we-offer" xs={12} className="w-100">
                <h2 className="px-4">Courses we offer</h2>
              </Col>

              {/* Courses Cards */}
              {courses
                .filter((item) => item.category !== "Professional Certificate")
                .map((item) => {
                  return (
                    <Col
                      key={item.id}
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      xl={4}
                      xxl={3}
                      className="mb-0 mb-md-3 d-flex justify-content-center"

                    >
                      <div style={{
                        width: "100%",
                        maxWidth: "350px",
                        minWidth: "280px",
                        display: "flex",
                        flexDirection: "column"
                      }}>
                        <CourseCard
                          id={item.id}
                          course_img={item.image}
                          course_title={item.program_title}
                          program_start_date={item.program_start_date}
                          duration={item.duration}
                          category={item.category}
                          program_type={item.program_type}
                          parent_program_ids={item.parent_program_ids}
                        />
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </div>
        </Container>
      </Container>


      {/* <Container fluid className="py-3 py-md-5 mb-3 mb-md-5 pb-3 pb-md-5"> */}
      <Container className="mb-5">
        <h2 className="py-2 pb-md-5 py-md-4 px-2 px-md-4 text-center fs-4 fs-md-2">
          Insights from Our Learners
        </h2>
        <div className="mb-3 mb-md-5">
          <ReviewSlider reviews={allReviews} />
        </div>
      </Container>

      <FooterTrust />
    </>
  );
};

export default TrustEdgeLanding;